module.exports = __webpack_public_path__ + "img/icon80.ccb15b74.png";